module.exports = __webpack_public_path__ + "static/media/alert-circle-error.0b07bf4d.svg";